/* These view helpers are designed for PRESENTATIONAL logic, to clean up your JS templates.
 * For instance, rather than writing:
 *
 *     <div class="foo [% if (isMultinational()) { %] hasMultinational[% } %]"></div>
 *
 * You can write
 *
 *     <div class="foo [%= addClassIfTrue(isMultinational(), "hasMultinational) %]"></div>
 *
 * Which is easier to read, and less prone to slip-ups with the brackets and the nesting.
 */

Pixlee = Pixlee || {};
Pixlee.viewHelpers = {
    addClassIfTrue: function(conditional, className) {
        if (conditional) {
            return ' ' + className;
        }
        return '';
    },

    /**
     * Used for rendering checkbox inputs.
     *
     * The output of this function should not be HTML escaped as it writes HTML.
     */
    checkedIfTrue: function(conditional) {
        if (conditional) {
            return 'checked="checked"';
        }
        return '';
    },
    /**
     * Used for hiding elements under certain circumstances. Generally the Marionette view
     * will display them if relevant.
     * 
     * The output of this function should not be HTML escaped as it writes HTML.
     */
    displayNoneIfTrue: function(conditional) {
        if (conditional) {
            return 'style="display: none"';
        }
        return '';
    },

    /**
     * Sets the background image for an element.
     *
     * The output of this function should not be HTML escaped as it writes HTML.
     * The url will be escaped if it isn't already escaped.
     * @param {string} url 
     * @returns 
     */
    backgroundImage: function(url) {
        var escapedUrl = _.unescape(url) === url ? _.escape(url) : url;
        return 'style="background-image: url(\'' + escapedUrl + '\')"';
    },

    /**
     * Helper method for adding attributes to a tag in a template.
     *
     * The output of this function should not be HTML escaped as it writes HTML.
     * The attributeValue will be escaped if it isn't already escaped.
     * @example
     * <button [%= addAttributeIfTrue(isDisabled, 'disabled') %]>Save</button>
     * <!-- becomes the following when true: -->
     * <button disabled>Save</button>
     * 
     * <div [%= addAttributeIfTrue(hasTarget, 'data-target', 'photo') %]></div>
     * <!-- becomes the following when true: -->
     * <div data-target="photo"></div>
     * @param {*} conditional a value to test for truthiness
     * @param {string} attribute HTML Attribute name
     * @param {string?} attributeValue Optional
     */
    addAttributeIfTrue: function(conditional, attribute, attributeValue) {
        if (conditional) {
            if (!attributeValue) {
                return attribute;
            }
            if (_.unescape(attributeValue) === attributeValue) {
                return attribute + '="' + _.escape(attributeValue) + '"';
            }
            return attribute + '="' + attributeValue + '"';
        }
        return '';
    },

    /**
     * Used to reuse simple markup like a list item with a label
     * @param {*} templateFunc
     * - In public/, this should be a template created by JST[]
     * - In app/, this should be a template imported via require()
     * @param {*} options Optional data to pass to the partial template
     */
    partial: function(templateFunc, options) {
        if (_.isFunction(templateFunc)) {
            return Marionette.Renderer.render(templateFunc, options || {});
        }
        throw new ArgumentError('templateFunc is not a function');
    }
};
